import {
  FETCH_MILESTONES_START, FETCH_MILESTONES_SUCCESS, FETCH_MILESTONES_ERROR,
  CREATE_MILESTONE_START, CREATE_MILESTONE_SUCCESS, CREATE_MILESTONE_ERROR,
  UPDATE_MILESTONE_START, UPDATE_MILESTONE_SUCCESS, UPDATE_MILESTONE_ERROR,
  DELETE_MILESTONE_START, DELETE_MILESTONE_SUCCESS, DELETE_MILESTONE_ERROR,
  SUBMIT_MILESTONE_START, SUBMIT_MILESTONE_SUCCESS, SUBMIT_MILESTONE_ERROR,
  REVIEW_SUBMISSION_START, REVIEW_SUBMISSION_SUCCESS, REVIEW_SUBMISSION_ERROR,
} from '../../Action/actionTypes'

const initialState = {
  milestones: [],
  currentCampaignId: null,
  campaignStatus: null,
  milestonesLoading: false,
  milestonesError: null,

  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  submitLoading: false,
  reviewLoading: false,
}

const updateMilestoneInList = (milestones, updated) =>
  milestones.map((m) => m.id === updated.id ? { ...m, ...updated } : m)

const updateSubmissionInMilestone = (milestones, updatedSub) =>
  milestones.map((m) => {
    if (m.id !== updatedSub.milestone_id) return m
    return {
      ...m,
      status: updatedSub.status === 'approved'
        ? 'approved'
        : updatedSub.status === 'revision_needed'
          ? 'revision_needed'
          : m.status,
      payment_released: updatedSub.status === 'approved' ? true : m.payment_released,
      latest_submission: updatedSub,
    }
  })

const milestoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MILESTONES_START:
      return { ...state, milestonesLoading: true, milestonesError: null, currentCampaignId: action.payload }
    case FETCH_MILESTONES_SUCCESS:
      return {
        ...state,
        milestonesLoading: false,
        milestones: action.payload.milestones,
        currentCampaignId: action.payload.campaignId,
        campaignStatus: action.payload.campaign_status ?? null,
        workflow: action.payload.workflow ?? null,
        proposal: action.payload.proposal ?? null
      }
    case FETCH_MILESTONES_ERROR:
      return { ...state, milestonesLoading: false, milestonesError: action.payload }

    case CREATE_MILESTONE_START:
      return { ...state, createLoading: true }
    case CREATE_MILESTONE_SUCCESS:
      return { ...state, createLoading: false, milestones: [...state.milestones, action.payload].sort((a, b) => a.position - b.position) }
    case CREATE_MILESTONE_ERROR:
      return { ...state, createLoading: false }

    case UPDATE_MILESTONE_START:
      return { ...state, updateLoading: true }
    case UPDATE_MILESTONE_SUCCESS:
      return { ...state, updateLoading: false, milestones: updateMilestoneInList(state.milestones, action.payload) }
    case UPDATE_MILESTONE_ERROR:
      return { ...state, updateLoading: false }

    case DELETE_MILESTONE_START:
      return { ...state, deleteLoading: true }
    case DELETE_MILESTONE_SUCCESS:
      return { ...state, deleteLoading: false, milestones: state.milestones.filter((m) => m.id !== action.payload) }
    case DELETE_MILESTONE_ERROR:
      return { ...state, deleteLoading: false }

    case SUBMIT_MILESTONE_START:
      return { ...state, submitLoading: true }
    case SUBMIT_MILESTONE_SUCCESS: {
      const sub = action.payload
      return {
        ...state,
        submitLoading: false,
        milestones: state.milestones.map((m) =>
          m.id === sub.milestone_id
            ? { ...m, status: 'submitted', latest_submission: sub }
            : m
        ),
      }
    }
    case SUBMIT_MILESTONE_ERROR:
      return { ...state, submitLoading: false }

    case REVIEW_SUBMISSION_START:
      return { ...state, reviewLoading: true }
    case REVIEW_SUBMISSION_SUCCESS:
      return { ...state, reviewLoading: false, milestones: updateSubmissionInMilestone(state.milestones, action.payload) }
    case REVIEW_SUBMISSION_ERROR:
      return { ...state, reviewLoading: false }

    default:
      return state
  }
}

export default milestoneReducer
